// JavaScript source code
import React from "react";
import {
    Menu,
    Input,
    Grid,
    Divider,
    Segment,
    Dropdown,
    Header,
    Transition,
    Icon,
    Label,
    Popup,
    Form,
    Confirm,
    Modal,
    Button
} from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import moment from "moment";
import "./CreateUser.css";
import DayPickerInput from "react-day-picker/DayPickerInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModernDatepicker from "react-modern-datepicker";
import LoadingBar from "react-redux-loading-bar";
import "react-day-picker/lib/style.css";
import Validation from "../../../Common/Utility/Validation";
import { NotificationStack } from "../../../Common/Notification";
import User_Header from "./User_header";
import Footer from "../../../Common/Layout/Footer";
import RASCal from "./RasCal";
import BuildRASInfo from "./RasInfo";
import UserRights from "../UserRights";
import * as ManageCreateUser from "./ManageCreateUser";
import * as action_type from "../../../actions/users/createUserAction";
import { connect } from "react-redux";
import LoopUpUtilities from "../../../Common/Utility/LookUpDataMapping";
import { Dimmer, Loader } from "semantic-ui-react";
import { fetchActiveCategories } from "../../../actions/categories/fetchActiveCategories"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import svg_icon_path from "../../../static/media/SVGSpriteIcon.svg";

import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";

var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}
class CreateUser extends React.Component {
    constructor(props) {
        super();
        this.UserForm = React.createRef();
        this.activemodule = "";
        this.activescroll = true;
        this.rasdeleteindex = -1;
        this.rastimeedit = false;
        this.statechanged = false;
        this.GLOBALUSER = false;
        this.GLOBALBRANCH_ID = 1;
        this.raschangeindex = [];
        this.raserrormsg = "";
        this.WEEK = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        // this.request_status=false;
        this.urlPath = props.match.path;
        this.SSO = userDetails && userDetails.UserContext.FirmEnableSSO ? userDetails.UserContext.FirmEnableSSO : "N";
        this.FirmLinkedToAxcess = userDetails && userDetails.UserContext.FirmLinkedToAxcess ? userDetails.UserContext.FirmLinkedToAxcess : false;
        this.state = {
            notifications: [],
            error_signal: { value: false, msg: "* Please fill the required fields" },
            request_status: { value: false },
            RASinfopop_status: { value: false },
            delete_confirm: { value: false },
            close_confirm: { value: false },
            rights_change: { value: true },
            showTopArrow: { value: false },
            //defaultCategory: 0,
            // allCategories: [
            //   {id: 1, text: "Tax", value: "Tax"},
            //   {id: 2, text: "Bookkeeping", value: "Bookkeeping"},
            //   {id: 3, text: "Financial", value: "Financial"},
            //   {id: 4, text: "Others", value: "Others"}
            // ],
            defaultCat: {
                type: "select",
                edited: false,
                defaultCategory: 0,
                default: ""
            },
            user_id: {
                type: "text",
                value: 0,
                required: false,
                default: "",
                minLength: 3,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            first_name: {
                type: "text",
                value: "",
                required: true,
                changed: false,
                edited: false,
                default: "",
                minLength: 1,
                maxLength: 50,
                error: false,
                regexp: "name",
                errormsg: ""
            },
            last_name: {
                type: "text",
                value: "",
                required: true,
                changed: false,
                edited: false,
                default: "",
                minLength: 1,
                maxLength: 50,
                error: false,
                regexp: "name",
                errormsg: ""
            },
            middle_name: {
                type: "text",
                value: "",
                required: false,
                changed: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 60,
                error: false,
                regexp: "name",
                errormsg: ""
            },
            email_id: {
                type: "text",
                value: "",
                required: true,
                changed: false,
                edited: false,
                default: "",
                minLength: 3,
                maxLength: 50,
                error: false,
                regexp: "email",
                errormsg: ""
            },
            password: {
                type: "password",
                value: "",
                required: (this.SSO === "N") ? true : false,
                changed: false,
                edited: false,
                show: (this.SSO === "N") ? true : false,
                default: "",
                minLength: 8,
                maxLength: 20,
                error: false,
                regexp: "password",
                errormsg: ""
            },
            confirmpassword: {
                type: "confirmpassword",
                value: "",
                required: false,
                changed: false,
                show: (this.SSO === "N") ? true : false,
                edited: false,
                default: "",
                minLength: 8,
                maxLength: 20,
                error: false,
                regexp: "password",
                errormsg: ""
            },
            employee_id: {
                type: "text",
                value: "",
                required: false,
                changed: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 100,
                error: false,
                regexp: "empid",
                errormsg: ""
            },
            task_locations: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 3,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            department: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            UserGuid: {
                type: "text",
                value: "",
                required: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            StaffGuid: {
                type: "text",
                value: "",
                required: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },            
            generation_type: {
                type: "select",
                value: "",
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            phone_number: {
                type: "text",
                value: "",
                required: false,
                changed: false,
                edited: false,
                default: "",
                minLength: 10,
                maxLength: 15,
                error: false,
                regexp: "phone",
                errormsg: ""
            },
            countryCode: {
                type: "text",
                value: "",
                required: false,
                changed: true,
                edited: true,
                default: "",
                error: false,
                regexp: "",
                errormsg: ""
            },
            branch_id: {
                type: "select",
                value: "",
                required: true,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            page_id: {
                type: "select",
                value: ["My Tasks"],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                countvalid: true,
                errormsg: ""
            },
            LandingPageId: {
                type: "select",
                value: "",
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            belongsto_group: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            parttime_employee: {
                type: "radio",
                value: "0",
                required: false,
                edited: false,
                default: "0",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            title_level: {
                type: "select",
                value: "",
                required: false,
                default: "",
                edited: false,
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            primary_role: {
                type: "select",
                value: "",
                required: false,
                default: "",
                edited: false,
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            industry_group: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            wrk_exp_begindate: {
                type: "text",
                value: "",
                required: false,
                changed: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            secondarybilling_rate: {
                type: "text",
                value: "",
                required: false,
                changed: false,
                default: "",
                minLength: 0,
                maxLength: 12,
                error: false,
                regexp: "decimal",
                errormsg: ""
            },
            ResidenceCity: {
                type: "text",
                value: "",
                required: false,
                default: "",
                changed: false,
                edited: false,
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            expertise: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            secondary_role: {
                type: "select",
                value: "",
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            niche_group: {
                type: "select",
                value: [],
                required: false,
                edited: false,
                default: "",
                minLength: 0,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            },
            YearsOfExp: {
                type: "text",
                value: "",
                required: false,
                default: "",
                edited: false,
                changed: false,
                minLength: 0,
                maxLength: 2,
                error: false,
                regexp: "number",
                errormsg: ""
            },
            primarybilling_rate: {
                type: "text",
                value: "",
                required: false,
                default: "",
                changed: false,
                edited: false,
                minLength: 0,
                maxLength: 12,
                error: false,
                regexp: "decimal",
                errormsg: ""
            },
            IP_from: {
                type: "ip_field",
                value: [{ from: "", to: "" }],
                required: false,
                default: [{ from: "", to: "" }],
                maxcount: 5,
                minLength: 3,
                maxLength: 50,
                error: false,
                regexp: "ip",
                errormsg: ""
            },
            ResourceAvailabilities: {
                type: "componentras",
                editweek: this.EditWeek,
                value: [this.defaultRASValue(true)],
                default: [this.defaultRASValue(true)],
                error: false,
                errormsg: ""
            },
            UserRights: { type: "componentrights", value: [], default: [] },
            cUserFullName: {
                type: "text",
                value: "",
                required: false,
                default: "",
                minLength: 3,
                maxLength: 50,
                error: false,
                regexp: "",
                errormsg: ""
            }            
        };
        const loaderPosition = {
            top:
                "" +
                (window.pageYOffset + document.documentElement.clientHeight / 2) +
                "px"
        };
    }

    userObject = () => {
        return {
            department: this.state.department.value,
            location: this.state.branch_id.value,
            primary_role: this.state.primary_role.value,
            email_id: this.state.email_id.value,
            user_name: this.state.cUserFullName.value,
            addUser: this.addUser,
            cancelUser: this.cancelUser,
            closeProfile: this.closeProfilePage,
            saveUser: this.addUser,
            discardUser: this.discardUser,
            dummyEdit: this.showEdit,
            disable_save: this.statechanged,
            request_status: this.state.request_status.value,
            defaultCategory: this.state.defaultCat.defaultCategory
        };
    };

    onDismiss(notification) {
        let item = this.state.notifications.indexOf(notification);
        let arr = this.state.notifications;
        arr.splice(item, 1);
        this.setState({
            notifications: arr
        });
    }
    defaultRASValue(_status, _props) {
        try {
            let _currmon = new Date().getMonth() + 1;
            if (!_status) {
                if (_props) {
                    /* var userDetails = localStorage.getItem("userDetails");
                    if (userDetails) {
                      userDetails = JSON.parse(userDetails);
                    }*/
                    var _res = this.props.profile_lookup.FirmCalSettings.filter(
                        xx => xx.branch_name === _props
                    );
                    if (_res.length) {
                        this.setState(prevState => {
                            let _tempfield = Object.assign({}, prevState);
                            //if(_tempfield.ResourceAvailabilities.value.length){
                            //_tempfield.ResourceAvailabilities.value=[];
                            _tempfield.ResourceAvailabilities.value.map(xy => {
                                xy.map(xz => {
                                    if (xz.name == "Deleted") xz.value = "Y";
                                });
                            });
                            _res.map(aa => {
                                let _def = aa.No_of_Hrs,
                                    _sat = aa.Sat_No_of_Hrs,
                                    _sun = aa.Sun_No_of_Hrs,
                                    _tot = 0;
                                _tot = _def * 5 + _sat + _sun;
                                let _init = [
                                    { name: "ID", type: "hide", value: 0 },
                                    { name: "Deleted", type: "hide", value: "N" },
                                    {
                                        name: "StartDate",
                                        type: "month-picker",
                                        value: new Date(
                                            aa.MonthFrom + "/" + new Date().getFullYear()
                                        )
                                    },
                                    {
                                        name: "EndDate",
                                        type: "month-picker",
                                        value: new Date(aa.MonthTo + "/" + new Date().getFullYear())
                                    },
                                    { name: "Mon", type: "editable", value: "" + _def + "h" },
                                    { name: "Tue", type: "editable", value: "" + _def + "h" },
                                    { name: "Wed", type: "editable", value: "" + _def + "h" },
                                    { name: "Thu", type: "editable", value: "" + _def + "h" },
                                    { name: "Fri", type: "editable", value: "" + _def + "h" },
                                    { name: "Sat", type: "editable", value: "" + _sat + "h" },
                                    { name: "Sun", type: "editable", value: "" + _sun + "h" },
                                    { name: "Total", type: "noneditable", value: _tot }
                                ];
                                _tempfield.ResourceAvailabilities.value.push(_init);
                                return _tempfield;
                            });
                            // }
                        });
                    } else {
                        let _def = 0,
                            _sat = 0,
                            _sun = 0,
                            _tot = 0;
                        _tot = _def * 5 + _sat + _sun;
                        let _init = [
                            { name: "ID", type: "hide", value: 0 },
                            { name: "Deleted", type: "hide", value: "N" },
                            { name: "StartDate", type: "month-picker", value: "" },
                            { name: "EndDate", type: "month-picker", value: "" },
                            { name: "Mon", type: "editable", value: "" + _def + "h" },
                            { name: "Tue", type: "editable", value: "" + _def + "h" },
                            { name: "Wed", type: "editable", value: "" + _def + "h" },
                            { name: "Thu", type: "editable", value: "" + _def + "h" },
                            { name: "Fri", type: "editable", value: "" + _def + "h" },
                            { name: "Sat", type: "editable", value: "" + _sat + "h" },
                            { name: "Sun", type: "editable", value: "" + _sun + "h" },
                            { name: "Total", type: "noneditable", value: _tot }
                        ];
                        return _init;
                    }
                }
            } else {
                let _def = 0,
                    _sat = 0,
                    _sun = 0,
                    _tot = 0;
                _tot = _def * 5 + _sat + _sun;
                let _init = [
                    { name: "ID", type: "hide", value: 0 },
                    { name: "Deleted", type: "hide", value: "N" },
                    { name: "StartDate", type: "month-picker", value: "" },
                    { name: "EndDate", type: "month-picker", value: "" },
                    { name: "Mon", type: "editable", value: "" + _def + "h" },
                    { name: "Tue", type: "editable", value: "" + _def + "h" },
                    { name: "Wed", type: "editable", value: "" + _def + "h" },
                    { name: "Thu", type: "editable", value: "" + _def + "h" },
                    { name: "Fri", type: "editable", value: "" + _def + "h" },
                    { name: "Sat", type: "editable", value: "" + _sat + "h" },
                    { name: "Sun", type: "editable", value: "" + _sun + "h" },
                    { name: "Total", type: "noneditable", value: _tot }
                ];
                return _init;
            }
        } catch (e) {
            // console.log("CreateUser-->defaultRASValue",e);
        }
    }

    showEdit = () => {
        this.props.history.push("/edituser/107983/edit");
    };

    redirect = () => {
        this.props.CHANGE_STATUS();
        if (window.parent.location.pathname === "/xcmv2/WorkflowIntegration/IntegrationDashboard" || window.parent.location.pathname === "/workflowweb/WorkflowIntegration/IntegrationDashboard") {
            this.props.history.push("/stafflinkingindex");
        }
        else
            this.props.history.push("/");

        this.setState(prevState => {
            let _tempfield = Object.assign({}); // creating copy of state variable jasper
            _tempfield.error_signal.msg = null; // update the name property, assign a new value
            _tempfield.error_signal.value = false;
            return _tempfield; // return new object jasper object
        });
        this.statechanged = true;
    };

    showErrMsg = () => { };
    bringTop = () => {
        document.querySelector(".withbg a").click();
    };

    buildIPAddress = (_value, _index) => {
        try {
            return (
                <div
                    className={`inline field ip_field ${this.state.IP_from.error ? "error" : ""
                        }`}
                    key={_index}
                >
                    <input
                        type="text"
                        name="IP_from"
                        value={_value.from}
                        onChange={e => this.handleChange(e, _index, "from")}
                    />
                    <span> - </span>
                    <input
                        type="text"
                        name="IP_from"
                        value={_value.to}
                        onChange={e => this.handleChange(e, _index, "to")}
                    />
                    <Popup
                        content="Delete the IP address range."
                        trigger={
                            <button
                                className={_index === 0 ? "hide" : "ui icon red button"}
                                disabled={_index === 0}
                                onClick={e => this.removeIP(e, _index)}
                            >
                                {" "}
                                <svg className={"svg_icon xcm-icon-close size-24 red"}>
                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-close`}> </use>
                                </svg>{" "}
                            </button>
                        }
                    />
                </div>
            );
        } catch (e) {
            console.log("CreateUser-->buildIPAddress", e);
        }
    };
    addNewIP = e => {
        try {
            e.preventDefault();
            this.statechanged = true;
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                let _max = _tempfield.IP_from.maxcount;
                let _count = _tempfield["IP_from"].value.length;
                if (_count < _max)
                    _tempfield["IP_from"].value.push({ from: "", to: "" });
                return _tempfield;
            });
        } catch (e) {
            console.log("CreateUser-->addNewIP", e);
        }
    };
    removeIP = (e, _index) => {
        try {
            e.preventDefault();
            this.statechanged = true;
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                if (_tempfield["IP_from"].value.length > 1)
                    _tempfield["IP_from"].value.splice(_index, 1);
                _tempfield["IP_from"].error = false;
                return _tempfield;
            });
        } catch (e) {
            console.log("CreateUser-->removeIP", e);
        }
    };

    checkDuplicateRAS = () => {
        let _checkRAS = false;
        if (
            this.props.profile_lookup.ShowRAS &&
            this.state.parttime_employee.value === "1"
        ) {
            let _dayofyear = [];
            let _fulllistdayofyear = [];
            let _activeras = [];
            let _emptydate = false;
            if (this.state.ResourceAvailabilities.value.length) {
                this.state.ResourceAvailabilities.value.map(aa => {
                    return aa.map(bb => {
                        if (bb.name == "Deleted" && bb.value == "N") _activeras.push(aa);
                    });
                });
            }
            _activeras.map(dd => {
                return dd.map(ff => {
                    if (ff.type === "month-picker" && ff.value === "") _emptydate = true;
                });
            });
            if (!_emptydate) {
                _activeras.map(xy => {
                    return xy.filter(xz => {
                        if (xz.type == "month-picker") {
                            if (xz.value === "") return false;
                            let _now = new Date(xz.value);
                            let _start = new Date(_now.getFullYear(), 0, 0);
                            let _diff = _now - _start;
                            let _oneDay = 1000 * 60 * 60 * 24;
                            let _day = Math.floor(_diff / _oneDay);
                            _dayofyear.push(_day);
                        }
                    });
                });
                // _dayofyear.sort();
                while (_dayofyear.length) {
                    let _x = _dayofyear.shift();
                    let _y = _dayofyear.shift();
                    // if(_x<=_y){
                    if (_x <= _y) {
                        for (let _i = _x; _i <= _y; _i++) _fulllistdayofyear.push(_i);
                    } else {
                        for (let _i = _x; _i <= 366; _i++) _fulllistdayofyear.push(_i);
                        for (let _i = 1; _i <= _y; _i++) _fulllistdayofyear.push(_i);
                    }
                    /* }
                           else{ 
                              _checkRAS=true;
                               return false;}*/
                }
                new Set(_fulllistdayofyear).size === _fulllistdayofyear.length
                    ? (_checkRAS = false)
                    : (_checkRAS = true);
                if (_checkRAS)
                    this.raserrormsg = "* Date Range already exist";
            }
            else {
                _checkRAS = true;
                this.raserrormsg = "* Date field cannot be blank";
            }
        }
        return _checkRAS;
    };

    addUser = e => {
        try {
            e.preventDefault();
            //console.log(this.state);
            let _errormsgexception = ["ip_field", "confirmpassword", "password"];
            let _preState = JSON.parse(JSON.stringify(this.state));
            let _status = Validation.UserProfileValidation(_preState);
            //console.log("Final",_status);
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState); // creating copy of state variable jasper
                _tempfield = _status; // update the name property, assign a new value
                return _tempfield; // return new object jasper object
            });
            let _error = Object.values(_status).filter(
                x => x.type !== "componentras" && x.error === true);
            
            if (_error.length > 0) {
                // console.log("Error");
                let _emsg = "* Please fill the required fields";
                _error.map(x => {
                    if (_errormsgexception.includes(x.type)) _emsg = (x.errormsg.length) ? x.errormsg : _emsg;
                    else if (x.regexp == "email" && x.value.length > 0)
                        _emsg = "* Enter valid email address";
                    else if (x.regexp == "phone" && (x.default.length < x.minLength || x.default.length > x.maxLength || x.value.length > 20))
                        _emsg = "* Enter valid phone number";
                    else if (x.regexp == "empid") _emsg = x.errormsg;
                    else if (x.countvalid)
                        _emsg = "* Users can have up to 7 views pinned to their MyView";

                });
                this.setState(prevState => {
                    let _tempfield = Object.assign({}, prevState);
                    _tempfield.error_signal.value = true;
                    _tempfield.error_signal.msg = _emsg;
                    _tempfield.close_confirm.value = false; // update the name property, assign a new value
                    return _tempfield;
                });
                this.bringTop();
            } else {
                if (!this.checkDuplicateRAS()) {
                    this.setState(prevState => {
                        let _tempfield = Object.assign({}, prevState);
                        _tempfield.error_signal.value = false;
                        _tempfield.request_status.value = true;
                        _tempfield.ResourceAvailabilities.error = false;
                        return _tempfield;
                    });
                    this.statechanged = false;
                    !this.props.match.params.id
                        ? this.props.POST_USER_DETAILS(
                            this.state,
                            this.props.profile_lookup
                        )
                        : this.props.PUT_USER_DETAILS(
                            this.state,
                            this.props.profile_lookup
                        );
                } else {
                    //alert('Invalid date range');
                    this.setState(prevState => {
                        let _tempfield = Object.assign({}, prevState);
                        _tempfield.ResourceAvailabilities.error = true;
                        _tempfield.ResourceAvailabilities.errormsg = this.raserrormsg;
                        return _tempfield;
                    });
                    document.querySelectorAll(".withbg a")[1].click();
                }
            }
        } catch (e) {
            console.log("CreateUser-->addUser", e);
        }
    };
    cancelUser = e => {


        try {
            e.preventDefault();
            let _state = Object.assign({}, this.state);

            _state = Object.values(_state).map(_obj => {
                if (_obj["type"] == "componentras") {
                    _obj.value = [this.defaultRASValue(true)];
                    _obj.default = [this.defaultRASValue(true)];
                }
                if (_obj["type"] == "componentrights") {
                    _obj.value.map(x => {
                        x.map(y => {
                            y.Access = "N";
                            y.Grouplist.map(zz => {
                                zz.GroupShow = false;
                            });
                            y.Disabled = false;

                        });
                    });
                }
                //nextProps.profile_lookup.moduleMaster
                _obj.value = _obj.default;
                _obj.error = false;
                _obj.edited = false;
                _obj.changed = false;
                _obj.errormsg = "";
                return _obj;
            });
            this.setState({
                defaultCat: { ...this.state.defaultCat, edited: false, defaultCategory: 0 },
                phone_number: {
                    value: ""
                },
                countryCode: {
                    value: "1"
                }
            });
            this.setState({ _state });
            this.statechanged = false;
        } catch (e) {
            console.log("CreateUser-->cancelUser", e);
        }
    };

    closeProfilePage = () => {
        if (this.statechanged) {
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                _tempfield.close_confirm.value = true;
                _tempfield.error_signal.msg = null;
                _tempfield.error_signal.value = false;
                return _tempfield;
            });
            this.statechanged = true;
        } else this.redirect();
    };

    defaultViewOptions = () => {
        let excludedCategories = ["My Points"];
        let pageDetails = this.props.profile_lookup.pageDetails;
        let selectedPinnnedViews = this.state.page_id.value;
        let optionsForDefaultView = pageDetails ? pageDetails.filter((pd) => !excludedCategories.includes(pd.value) && selectedPinnnedViews.includes(pd.value)) : [];
        // console.log("selectedPinnnedViews", pageDetails, selectedPinnnedViews, optionsForDefaultView)
        return optionsForDefaultView ? optionsForDefaultView : []
        // return this.props.profile_lookup
        //   ? this.props.profile_lookup.pageDetails
        //   : []
    }

    stayinProfilePage = () => {
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            _tempfield.close_confirm.value = false;
            return _tempfield;
        });
    };

    discardUser = (e) => {
        try {
            e.preventDefault();
            let _state = Object.assign({}, this.state);
            let elem = document.querySelectorAll("label.edited");
            for (var i = 0; i < elem.length; i++) {
                elem[i].classList.remove('edited');
            }
            _state = Object.values(_state).map(_obj => {
                _obj.edited = false;
                _obj.changed = false;
                return _obj
            });
            this.setState({ _state });
            this.statechanged = false;
            let userId = window.atob(this.props.match.params.id);
            this.props.GET_USER_DETAILS(parseInt(userId));
            this.setState({
                phone_number: {
                    value: this.props.user_details.phone_number
                },
                countryCode: {
                    value: this.props.user_details.countryCode.replace(/\D/g, "")
                }
            })
        }
        catch (e) {
            console.log("CreateUser-->discardUser", e);
        }
    };

    textColorChange = (e, _name) => {
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            if (_tempfield[_name].edited === true) {
                _tempfield[_name].changed = true;
                return _tempfield;
            }
        });
    };
    // Validate Employee ID on blur and show the global banner (errmsg errshow) when invalid.
    validateEmployeeIdOnBlur = (e) => {
        try {
            const raw = e?.target?.value ?? "";
            const trimmed = raw.trim();

            this.setState(prev => {
                const next = { ...prev };

                // Optional field: empty is OK → clear field error and (if set) the banner
                if (trimmed.length === 0) {
                    next.employee_id.error = false;
                    next.employee_id.errormsg = "";
                    if (
                        next.error_signal.value &&
                        typeof next.error_signal.msg === "string" &&
                        next.error_signal.msg.startsWith("* Employee ID is not valid")
                    ) {
                        next.error_signal.value = false;
                        next.error_signal.msg = "";
                    }
                    return next;
                }

                // Non-empty → run centralized regex once on blur
                const isValid = Validation.KeyPressValidation(false, "empid", trimmed);
                if (!isValid) {
                    next.employee_id.error = true;
                    next.employee_id.errormsg =
                        "* Employee ID is not valid. Allowed characters: letters (a-z, A-Z), digits (0-9), and special characters - _ ' @ . # ";
                    // Show the global strip used for other messages
                    next.error_signal.value = true;
                    next.error_signal.msg = next.employee_id.errormsg;
                    this.bringTop();
                } else {
                    next.employee_id.error = false;
                    next.employee_id.errormsg = "";
                    if (
                        next.error_signal.value &&
                        typeof next.error_signal.msg === "string" &&
                        next.error_signal.msg.startsWith("* Employee ID is not valid")
                    ) {
                        next.error_signal.value = false;
                        next.error_signal.msg = "";
                    }
                }
                return next;
            });
        } catch (err) {
            console.log("CreateUser-->validateEmployeeIdOnBlur", err);
        }
    };
    handleChange = (e, _index = 0, _obj) => {
        try {
            let _name = e.target.type
                ? e.target.name
                : e.target.offsetParent.parentElement.getAttribute("name");
            let _value = e.target.type ? e.target.value : e.target.textContent;
            this.setState(prevState => {
                // Allow clearing Employee ID to empty while typing (optional field)
                if (_name === "employee_id" && ((_value ?? "").trim().length === 0)) {
                    const next = { ...prevState };
                    next.employee_id.value = "";
                    next.employee_id.edited = true;
                    next.employee_id.error = false;   // no error for empty optional
                    next.employee_id.errormsg = "";
                    next.rights_change.value = false;
                    this.statechanged = true;
                    return next;
                }
                if (
                    Validation.KeyPressValidation(true, prevState[_name].regexp, _value)
                ) {
                    this.statechanged = true;
                    let _tempfield = Object.assign({}, prevState);
                    if (
                        typeof _tempfield[_name].value !== "object" ||
                        _tempfield[_name].value == null
                    ) {
                        if (_name === "parttime_employee") {
                            _tempfield.ResourceAvailabilities.error = false;
                            this.defaultRASValue(false, this.state.branch_id.value);
                            this.RASinfopop(e, false);
                        }
                        _tempfield[_name].value = _value;
                        _tempfield[_name].edited = true;
                    } else {
                        _tempfield[_name].value[_index][_obj] = _value;
                    }

                    if (_name === "password") {
                        _tempfield["confirmpassword"].show = true;
                    }
                    _tempfield.rights_change.value = false;
                    _tempfield[_name].error = false;
                    return _tempfield;
                }
            });
        } catch (e) {
            console.log("CreateUser-->handleChange", e);
        }
    };


    calenderChange(_day) {
        this.statechanged = true;
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            _tempfield.wrk_exp_begindate.value = _day;
            _tempfield.wrk_exp_begindate.edited = true;
            return _tempfield;
        });
    }
    assignDate(_day) {
        if (typeof this.state.wrk_exp_begindate.value === "object")
            return new Date(this.state.wrk_exp_begindate.value);
        else if (this.state.wrk_exp_begindate.value.length > 0) {
            let _dd = new Date(this.state.wrk_exp_begindate.value);
            if (_dd.getFullYear() != 1900) return _dd;
            else return "";
        } else return "";
    }

    selectDefaultCategory() {
        if (this.state.defaultCat.defaultCategory == 0) {
            return ""
        }
        if (this.props.categories && this.props.categories.length) {
            const defaultCat = this.props.categories.filter(el => el.category_id === this.state.defaultCat.defaultCategory);
            if (defaultCat && defaultCat.length) {
                return defaultCat[0].name
            } else {
                // alert("Inactive categories cannot be selected")
                // const mySuccessNotification = {
                //   message: "Default category cannot be selected since the category is in inactive state",
                //   type: NOTIFICATION_TYPE_WARNING,
                //   duration: 5000,
                //   canDismiss: true,
                //   showCloseAllBtn: true
                // };
                // this.props.createNotification(mySuccessNotification);
                return ""
            }
        } else {
            return ""
        }
    }

    handleDropdownChange(_name, _value, e) {
        try {
            this.statechanged = true;
            if (_name == "belongsto_group") {
                let _res = [];
                if (!_value.value.length) {
                    this.state.belongsto_group.value.map(xx => {
                        var _o = new Object();
                        _o.value = xx;
                        _o.Access = "N";
                        _res.push(_o);
                    });
                } else if (!this.state.belongsto_group.value.length) {
                    _value.value.map(xx => {
                        var _o = new Object();
                        _o.value = xx;
                        _o.Access = "Y";
                        _res.push(_o);
                    });
                } else if (
                    this.state.belongsto_group.value.length &&
                    _value.value.length
                ) {
                    if (_value.value.length > this.state.belongsto_group.value.length) {
                        _value.value.map(xx => {
                            var _o = new Object();
                            _o.value = xx;
                            _o.Access = "Y";
                            _res.push(_o);
                        });
                    } else {
                        this.state.belongsto_group.value.map(xx => {
                            var _o = new Object();
                            _o.value = xx;
                            if (_value.value.indexOf(xx) != -1) _o.Access = "Y";
                            else _o.Access = "N";
                            _res.push(_o);
                        }, this);
                    }
                }
                this.checkUserRights(_res);
            }

            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                // to restrict pinned views values to 7 

                if (_name === "page_id") {

                    let default_view = _tempfield.LandingPageId.value;
                    if (!_value.value.includes(default_view)) {
                        _tempfield["LandingPageId"].value = "";
                    }
                    console.log("Temp Filed", _tempfield, _name, _value, default_view)

                }


                _tempfield[_name].value = _value.value;
                _tempfield.rights_change.value =
                    _name === "belongsto_group" ? true : false;
                _tempfield[_name].error = false;
                _tempfield[_name].edited = true;
                return _tempfield;
            });
            /* if(_name=="branch_id"){
                          this.defaultRASValue(false,_value.value);
                       } 
                       if(e){
                       e.persist();
                       let _e=e;
                       setTimeout(()=>{
                          _e.target.parentElement.parentElement.parentElement.querySelector(".text").setAttribute('class','text editedCellColor');
                       //_e.target.offsetParent.offsetParent.offsetParent.querySelector(".default").setAttribute('class','default text editedCellColor');                                      
                       },100);
                      }*/
        } catch (e) {
            console.log("CreateUser-->handleDropdownChange", e);
        }
    }

    checkUserRights = _value => {
        this.statechanged = true;
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            _value.map(aa => {
                _tempfield.UserRights.value.map(bb => {
                    return bb.map(cc => {
                        let _res = cc.Grouplist.filter(dd => dd.Group_Name === aa.value);
                        if (_res.length) {
                            _res[0].GroupShow = aa.Access == "Y" ? true : false;
                            let _acc = cc.Grouplist.filter(x => x.GroupShow === true);
                            if (_acc.length) {
                                cc.Access = "Y";
                                cc.Mutual.map(mu => {
                                    let _cc = bb.filter(
                                        ca => ca.ModuleID === (mu !== cc.ModuleID ? mu : -1)
                                    );
                                    if (_cc.length) _cc[0].Access = "N";
                                });
                                cc.Disabled = true;
                                if (cc.ModuleID == 58)
                                    this.props.CHANGE_MYCALENDER("add");
                            } else {
                                cc.Access = aa.Access;
                                cc.Disabled = false;
                                if (cc.ModuleID == 58)
                                    this.props.CHANGE_MYCALENDER("remove");
                            }
                        }
                    });
                });
            });
            _tempfield.rights_change.value = true;
            return _tempfield;
        });
    };

    EditWeek = (e, _name, _index) => {
        try {
            let _selection, _range;
            this.statechanged = true;
            this.rastimeedit = true;
            e.target.setAttribute("contenteditable", "true");
            let _res = this.state.ResourceAvailabilities.value[_index].filter(
                x => x.name === _name
            );
            e.target.textContent = parseInt(_res[0].value);
            e.target.setAttribute("style", "border:1px solid yellow");
            let _divindex = e.target.parentElement.parentElement.getAttribute(
                "data-index"
            );
            _selection = window.getSelection();
            _range = document.createRange();
            _range.selectNodeContents(e.target);
            _selection.removeAllRanges();
            _selection.addRange(_range);
            this.raschangeindex.push({
                index: _index,
                week: _name,
                divindex: _divindex
            });
            /*this.state.ResourceAvailabilities.value.map(x=>{
                  return x.reduce((cc,xx)=>{return cc+(xx.type==="editable"?parseInt(xx.value,10):0)},0)
              })*/
        } catch (e) {
            console.log("CreateUser-->EditWeek", e);
        }
    };
    RASdaychange = (_day, _name, _index) => {
        try {
            this.statechanged = true;
            this.setState(prevState => {
                let _l = prevState.ResourceAvailabilities.value.length - 1;
                let _tempfield = Object.assign({}, prevState);
                _tempfield.ResourceAvailabilities.error = false;
                let _res = _tempfield.ResourceAvailabilities.value[_index].filter(
                    x => x.name === _name
                );
                if (_res.length > 0)
                    //_res[0].value=moment(_day).format('DD MMM');
                    _res[0].value = new Date(_day);
                /*if(_index===_l){
                        console.log("Add");                
                        prevState.ResourceAvailabilities.value.push([{name:"StartDate",type:"month-picker",value:moment(new Date()).format('DD MMM')},{name:"EndDate",type:"month-picker",value:moment(new Date()).format('DD MMM')},{name:"mon",type:"editable",value:"0h"},{name:"tue",type:"editable",value:"0h"},{name:"wed",type:"editable",value:"0h"},{name:"thu",type:"editable",value:"0h"},{name:"fri",type:"editable",value:"0h"},{name:"sat",type:"editable",value:"0h"},{name:"sun",type:"editable",value:"0h"},{name:"total",type:"noneditable",value:"0"}])              
                    }*/
                return _tempfield;
            });
        } catch (e) {
            console.log("CreateUser-->RASdaychange", e);
        }
    };
    addRASDetails = e => {
        e.preventDefault();
        this.statechanged = true;
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            prevState.ResourceAvailabilities.value.push(this.defaultRASValue(true));
            _tempfield.rights_change.value = false;
            return _tempfield;
        });
    };

    deleteRASDetails = (e, _index, _opt) => {
        e.preventDefault();
        this.statechanged = true;
        this.rasdeleteindex = _index;
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            _tempfield.delete_confirm.value = _opt;
            _tempfield.rights_change.value = false;
            return _tempfield;
        });
        /*this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);                 
                prevState.ResourceAvailabilities.value[_index].filter(x=>x.name=="Deleted")[0].value="Y"            
                return _tempfield ;
            });*/
    };
    rasConfirmDelete = e => {
        e.preventDefault();
        this.statechanged = true;
        if (this.rasdeleteindex != -1) {
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                _tempfield.ResourceAvailabilities.value[this.rasdeleteindex].filter(
                    x => x.name == "Deleted"
                )[0].value = "Y";
                _tempfield.ResourceAvailabilities.error = false;
                _tempfield.delete_confirm.value = false;
                _tempfield.rights_change.value = false;
                return _tempfield;
            });
        }
    };

    handleRASChange = (e, _name, _index) => {
        try {
            e.persist();
            this.statechanged = true;
            //console.log(e,_name,_index);
            if (e.which === 13) {
                this.setState(prevState => {
                    let _tempfield = Object.assign({}, prevState);
                    let _res = _tempfield.ResourceAvailabilities.value[_index].filter(
                        x => x.name === _name
                    ); // update the name property, assign a new value
                    if (_res.length > 0) {
                        if (
                            e.target.textContent.length > 0 &&
                            e.target.textContent.length <= 2 &&
                            !isNaN(Math.abs(e.target.textContent)) &&
                            Math.abs(e.target.textContent) < 13
                        ) {
                            _res[0].value = Math.abs(e.target.textContent) + "h";
                            e.target.setAttribute("style", "color:yellow");
                            let _total = _tempfield.ResourceAvailabilities.value.map(x => {
                                return x.reduce((cc, xx) => {
                                    return (
                                        cc + (xx.type === "editable" ? parseInt(xx.value, 10) : 0)
                                    );
                                }, 0);
                            });
                            _tempfield.ResourceAvailabilities.value[_index][
                                _tempfield.ResourceAvailabilities.value[_index].length - 1
                            ].value = _total[_index];
                        } else {
                            e.target.textContent = _res[0].value;
                        }
                    }
                    e.target.setAttribute("contenteditable", "false");
                    return _tempfield;
                });
                this.rastimeedit = false;
            }
        } catch (e) {
            console.log("CreateUser-->handleRASChange", e);
        }
    };

    userRightsChange = function (e, _index, _mid) {
        e.persist();
        this.statechanged = true;
        //console.log(_mid);
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            let category = _tempfield.UserRights.value[_index];
            let _res = category.filter(x => x.ModuleID === _mid);
            if (_res.length) {
                var aa = _res[0].Grouplist.filter(y => y.GroupShow === true);
                if (!aa.length) {
                    _res[0].Access = _res[0].Access == "N" ? "Y" : "N";
                    _tempfield.rights_change.value = true;
                    if (_res[0].Mutual.length) {
                        _res[0].Mutual.map(bb => {
                            let _cc = category.filter(
                                cc => cc.ModuleID === (bb !== _mid ? bb : -1)
                            );
                            if (_cc.length) _cc[0].Access = "N";
                        });
                    }
                    if (_res[0].ModuleID === 58) {
                        if (_res[0].Access == "Y")
                            this.props.CHANGE_MYCALENDER("add");
                        else
                            this.props.CHANGE_MYCALENDER("remove");
                    }
                }
            }
            return _tempfield;
        });
    };
    RASinfopop = (e, _status) => {
        this.setState(prevState => {
            let _tempfield = Object.assign({}, prevState);
            _tempfield.RASinfopop_status.value = _status;
            return _tempfield;
        });
    };
    handleClickOutside = e => {
        // console.log(e.target,e.target.parentElement);
        if (
            e.target.parentElement == null ||
            (e.target.getAttribute("class") != "RASweek" &&
                e.target.parentElement.getAttribute("class") != "RASweek")
        ) {
            let _div = document.getElementsByClassName("RASweek");
            _div = Array.prototype.slice.call(_div, 0);
            _div.map(x => {
                x.setAttribute("contenteditable", false);
                x.removeAttribute("style");
            });
            if (this.rastimeedit) {
                this.setState(prevState => {
                    let _tempfield = Object.assign({}, prevState);
                    _tempfield.rights_change.value = false;
                    if (this.raschangeindex.length) {
                        this.raschangeindex.map(xx => {
                            let _row = _div.slice(xx.divindex * 8, (xx.divindex + 1) * 8);
                            if (_row.length) {
                                let _value = _row[this.WEEK.indexOf(xx.week)].textContent;
                                if (
                                    _value.length > 0 &&
                                    _value.length <= 2 &&
                                    !isNaN(Math.abs(_value)) &&
                                    Math.abs(_value) < 13
                                ) {
                                    _row[this.WEEK.indexOf(xx.week)].textContent =
                                        Math.abs(_value) + "h";
                                    let _resu = _tempfield.ResourceAvailabilities.value[
                                        xx.index
                                    ].filter(vv => vv.name === xx.week);
                                    if (_resu.length) _resu[0].value = Math.abs(_value) + "h";
                                    let _total = _tempfield.ResourceAvailabilities.value.map(
                                        z => {
                                            return z.reduce((cc, yy) => {
                                                return (
                                                    cc +
                                                    (yy.type === "editable" ? parseInt(yy.value, 10) : 0)
                                                );
                                            }, 0);
                                        }
                                    );
                                    _tempfield.ResourceAvailabilities.value[xx.index][
                                        _tempfield.ResourceAvailabilities.value[xx.index].length - 1
                                    ].value = _total[xx.index];
                                }
                            }
                        });
                        this.raschangeindex = [];
                    }
                    return _tempfield;
                });
                this.rastimeedit = false;
            }
        }
    };

    profileNavigation = (e, _module) => {
        if (typeof this.activemodule != "string") {
            if (this.activemodule.currentTarget)
                this.activemodule.currentTarget.setAttribute("class", "item");
            else this.activemodule.className = "item";
        }
        e.currentTarget.setAttribute("class", "item active");
        this.activemodule = Object.assign({}, e);
        let _list = document.querySelectorAll(".js-title");
        _list = Array.from(_list);
        let _target = _list.filter(xx => {
            if (xx.innerText == _module) {
                return xx;
            }
        });
        if (_target.length) {
            let _pos = _target[0].offsetTop - 20;
            let _curr = window.pageYOffset;
            let _scroll = setInterval(() => {
                this.activescroll = false;
                if (_pos < _curr) {
                    let _diff = _curr - _pos;
                    _diff < 30 ? (_curr -= _diff) : (_curr -= 30);
                } else {
                    let _diff = _pos - _curr;
                    _diff < 30 ? (_curr += _diff) : (_curr += 30);
                }
                if (_curr != _pos) window.scrollTo(0, _curr);
                else {
                    window.scrollTo(0, _curr);
                    clearInterval(_scroll);
                    this.activescroll = true;
                }
            }, 10);
        }
    };

    handleScroll() {
        //console.log(window.scrollY);
        if (this.activescroll) {
            let _list = document.querySelectorAll(".js-title");
            _list = Array.from(_list);
            let _pageoffset = window.pageYOffset;
            let _topstate = _pageoffset > 100 ? true : false;
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                if (_tempfield.showTopArrow.value !== _topstate) {
                    _tempfield.showTopArrow.value = _topstate;
                    return _tempfield;
                }
            });
            let modules = _list.filter(function (dom) {
                var rangeEnd = _pageoffset + window.innerHeight;
                return dom.offsetTop >= _pageoffset && dom.offsetTop <= rangeEnd;
            });
            //console.log(modulesinscrollrange[0].innerText);
            if (modules.length) {
                let _res = LoopUpUtilities.ProfileNavigation.filter(xx => {
                    return xx.ref == modules[0].innerText;
                });
                if (_res.length) {
                    let _item;
                    document
                        .querySelectorAll(".js-leftFixedPanel .vertical a")
                        .forEach(xx => {
                            if (xx.innerText == _res[0].val) {
                                _item = xx;
                            }
                        });
                    if (_item) {
                        if (typeof this.activemodule != "string") {
                            if (this.activemodule.currentTarget)
                                this.activemodule.currentTarget.setAttribute("class", "item");
                            else this.activemodule.className = "item";
                        }
                        this.activemodule = _item;
                        _item.className = "item active";
                        //console.log(this);
                    }
                }
            }
        }
    }
    componentWillMount() {
        //console.log("Component will mount");
    }

    // static getDerivedStateFromProps(props, state) {
    //   console.log("########", props,state.categories)
    // }

    componentDidMount() {

        window.onbeforeunload = () => {
            if (this.userObject().disable_save) {
                return "";
            }
        };
        //console.log("userDetails.UserContext.firmId", userDetails.UserContext.firmId)
        let firmId = userDetails && userDetails.UserContext.firmId ? userDetails.UserContext.firmId : 697;
        // this.props.fetchActiveCategories(firmId)
        // .then((res) => {
        //   //console.log("RESPONSE FROM CAT : ", res)
        // });

        if (!this.props.categories.length) {
            this.props.fetchActiveCategories(firmId)
        }
        //console.log("component did mount");
        this.props.GET_USER_LOOKUPS();
        if (this.props.match.params.id) {
            //this.props.fetchActiveCategories(firmId)

            let userId = window.atob(this.props.match.params.id);
            this.props.GET_USER_DETAILS(parseInt(userId));
        }
        document.addEventListener("mousedown", this.handleClickOutside);
        this.activemodule = document.querySelector(
            ".js-leftFixedPanel .vertical a"
        );
        window.addEventListener("scroll", this.handleScroll.bind(this));

    }

    componentDidUpdate() {
        // console.log("component will update");
    }

    componentWillReceiveProps(nextProps) {
        let _preState;
        // alert(nextProps.db_status);
        // console.log("componentWillReceiveProps", nextProps,this.props);
        if (
            this.props.match.params.id &&
            Object.keys(nextProps.profile_lookup).length &&
            nextProps.db_status === "new"
        ) {
            // TODO
            // get firm_id from context
            //  get firm_id from user data(from server)
            // check both matches
            // if not redirect to unauth page
            try {
                _preState = JSON.parse(JSON.stringify(this.state));
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            let _state = LoopUpUtilities.LoadUserProfileDate(_preState, nextProps);
            if (_state.UserRights.value.length) {
                let _mycala = _state.UserRights.value[8].filter(xx => xx.ModuleID == 58);
                if (_mycala.length)
                    if (_mycala[0].Access == "Y")
                        this.props.CHANGE_MYCALENDER("add");
                    else
                        this.props.CHANGE_MYCALENDER("remove");

                //let _isUserglobal = _state.UserRights.value[3].filter(xx => xx.ModuleID == 8);
                //if (_isUserglobal[0].Access == "N") {
                //    let _staffIntegrationRight = _state.UserRights.value[2].filter(xx => xx.ModuleID == 68)[0];
                //    _staffIntegrationRight.Disabled = true;
                //}
            }
            if (nextProps.user_details.user_id !== 0) {
                if (nextProps.user_details.firm_id !== userDetails.UserContext.firmId) {
                    this.props.history.push("/notauth");
                }
            }
            // if(_state.first_name.value.length>0){
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState);
                _tempfield = _state;
                return _tempfield;
            });
            // }else{
            // this.redirect();
            // }

            // else{
        }
        if (this.GLOBALUSER == false) {
            if (
                Object.keys(nextProps.profile_lookup).length &&
                nextProps.db_status === "new"
            ) {
                this.setState(prevState => {
                    let _tempfield = Object.assign({}, prevState);
                    _tempfield.branch_id.value = nextProps.profile_lookup.firmBranches.filter(
                        xx => xx.key === this.GLOBALBRANCH_ID
                    )[0].value;
                    return _tempfield;
                });
            }
        }

        if (this.state.UserRights.value) {
            if (!this.state.UserRights.value.length) {
                this.setState(prevState => {
                    let _tempfield = Object.assign({}, prevState);
                    _tempfield.UserRights.value = (nextProps.profile_lookup.moduleMaster) ? nextProps.profile_lookup.moduleMaster : [];
                    _tempfield.UserRights.default = (nextProps.profile_lookup.moduleMaster) ? nextProps.profile_lookup.moduleMaster : [];
                    if (nextProps.profile_lookup.moduleMaster && !this.props.match.params.id)
                        this.props.CHANGE_MYCALENDER("remove");
                    return _tempfield;
                });
            }
        }

        if (
            localStorage.getItem("RASinfo") == "undefined" ||
            localStorage.getItem("RASinfo") == null
        ) {
            // console.log("localstorage");
            localStorage.setItem(
                "RASinfo",
                JSON.stringify(nextProps.profile_lookup.FirmCalSettings)
            );
            this.defaultRASValue(false, nextProps);
        }
        if (nextProps.db_status == "failed" || nextProps.db_status == "conflict" ) {
            //alert("email id");        
            this.setState(prevState => {
                let _tempfield = Object.assign({}, prevState); // creating copy of state variable jasper
                _tempfield.error_signal.value = true;
                _tempfield.email_id.error = true ;
                _tempfield.first_name.error = _tempfield.first_name.value;
                _tempfield.middle_name.error =_tempfield.middle_name.value;
                _tempfield.last_name.error = _tempfield.last_name.value;
                _tempfield.employee_id.error = !!_tempfield.employee_id.value;
                _tempfield.request_status.value = false;
                _tempfield.close_confirm.value = false;
                _tempfield.error_signal.msg = nextProps.db_status == "conflict" ? nextProps.error : "*Email-Id already exist."; // update the name property, assign a new value       
                return _tempfield; // return new object jasper object
            });
            this.statechanged = true;
        }
        // }
        /* if(this.props.db_status!=="new"){
                setTimeout(()=>{
                    this.props.history.push("/");
                },1000);            
            }*/
    }
    shouldComponentUpdate(nextProps, nextState) {
        //console.log("Should Update", nextProps, nextState, this.props);
        if (nextProps.match.params.id) {
            if (this.props.match.path != nextProps.match.path) {
                let userId = window.atob(nextProps.match.params.id);
                this.props.GET_USER_DETAILS(parseInt(userId));
            }
            /*if(nextProps.db_status=="updated"){
                      //this.props.GET_USER_DETAILS(parseInt(nextProps.match.params.id));
                      this.props.CHANGE_STATUS();   
                      this.redirect();           
                  }*/
            //this.statechanged=true;
        }
        if (nextProps.db_status == "inserted" || nextProps.db_status == "updated") {
            this.props.CHANGE_STATUS();
            this.redirect();
            const mySuccessNotification = {
                message: (nextProps.db_status == "inserted") ? "User added successfully" : "User updated successfully",
                type: NOTIFICATION_TYPE_SUCCESS,
                duration: 5000,
                canDismiss: true,
                showCloseAllBtn: true
            };
            this.props.createNotification(mySuccessNotification);
        }
        /* else if(nextProps.db_status=="failed"){
            this.request_status = false;
           }*/
        return true;
    }
    rasCloseIcon() {
        return (
            <>
                <div className="header">
                    Delete Resource Availability{" "}
                    <Icon
                        className="xcm-icon-close icon size-24"

                        onClick={e => this.deleteRASDetails(e, -1, false)}
                    />
                </div>
            </>
        );
    }
    profilePageCloseIcon() {
        return (
            <>
                <div className="header">
                    Warning{" "}
                    <Icon
                        className="xcm-icon-close icon size-24 j_remove_rightalign"
                        onClick={e => this.stayinProfilePage()}
                    />
                </div>
            </>
        );
    }
    render() {
        var userDetails = atob(localStorage.getItem("userDetails"));
        if (!userDetails) {
            return (
                <Redirect to={{
                    pathname: '/webapp/notauth',
                    state: { from: this.props.location }
                }}
                />
            );
        }
        else {
            try {
                userDetails = JSON.parse(userDetails);
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            let _userpermis = userDetails.Rights.filter(x => x.module_id == 4);
            if (_userpermis) {
                if (_userpermis[0].access === 0) {
                    return (
                        <Redirect to={{
                            pathname: '/webapp/notauth',
                            state: { from: this.props.location }
                        }}
                        />
                    );
                }
            }
            // console.log(userDetails, userDetails.Rights);
            let rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
            this.GLOBALBRANCH_ID = userDetails.UserContext.locationId;
            let RIGHT_ACCESS = rightsDetails[0].access;
            let MODULE_ID = rightsDetails[0].module_id;
            if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
                this.GLOBALUSER = true;
            }
        }
        return (
            <>

                <BuildRASInfo
                    open={this.state.RASinfopop_status.value}
                    click={this.RASinfopop}
                ></BuildRASInfo>
                <Modal open={this.state.delete_confirm.value} size="mini">
                    <Modal.Header>{this.rasCloseIcon()}</Modal.Header>
                    <Modal.Content>
                        <p>Are you sure to delete your schedule?</p>
                    </Modal.Content>
                    <Modal.Actions className="j_leftaction">
                        <Button.Group size="medium" className="j_group_medium_width">
                            <button
                                className="ui basic inverted green button fluid"
                                onClick={e => this.deleteRASDetails(e, -1, false)}
                            >
                                Cancel
              </button>
                            <button
                                className="ui basic inverted red button fluid"
                                onClick={e => this.rasConfirmDelete(e)}
                            >
                                Delete
              </button>
                        </Button.Group>
                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.close_confirm.value} size="small">
                    <Modal.Header>{this.profilePageCloseIcon()}</Modal.Header>
                    <Modal.Content>
                        <p>
                            You have unsaved changes on the Profile Page. Do you want to Save
                            or Close the Profile Page without saving changes?
            </p>
                    </Modal.Content>
                    <Modal.Actions className="j_leftaction">
                        <Button.Group size="medium" className="j_group_medium_width">
                            <button
                                className="ui basic inverted green button fluid"
                                onClick={e => this.addUser(e)}
                            >
                                Save & Close
              </button>
                            <button
                                className="ui basic inverted red button fluid"
                                onClick={e => this.redirect()}
                            >
                                Close Without Saving
              </button>
                        </Button.Group>
                    </Modal.Actions>
                </Modal>
                <User_Header
                    url={this.props.match.params}
                    userObject={this.userObject()}
                ></User_Header>
                <Divider hidden />
                <Transition
                    visible={
                        this.props.db_status == "updated" ||
                        this.props.db_status == "inserted" ||
                        this.props.db_status == "failed"
                    }
                    animation="scale"
                    duration={500}
                >
                    <div className="xcm-popup">User {this.props.db_status}</div>
                </Transition>

                <form
                    name="user_Form"
                    className="user_Form"
                    onSubmit={e => this.addUser(e)}
                    autocomplete="off"
                >
                    <a
                        onClick={e => this.bringTop()}
                        className={`scroll_top_arrow ${this.state.showTopArrow.value ? "showtoparrow" : ""
                            }`}
                    ></a>
                    {!Object.keys(this.props.profile_lookup).length ? (
                        <Dimmer page active inverted>
                            <Loader inverted>Loading</Loader>{" "}
                        </Dimmer>
                    ) : (
                            ""
                        )}

                    {this.state.request_status.value ? (
                        <Dimmer page active inverted>
                            <Loader inverted>Loading</Loader>{" "}
                        </Dimmer>
                    ) : (
                            ""
                        )}
                    <Grid className="profile-grid">
                        <Grid.Row>
                            <Grid.Column
                                width={3}
                                className="leftFixedPanel js-leftFixedPanel"
                            >
                                <Menu vertical className="withbg">
                                    {LoopUpUtilities.ProfileNavigation.map((_name, _index) => {
                                        if (_name.val === "Resource Availability") {
                                            return _name.show &&
                                                this.state.parttime_employee.value === "1" ? (
                                                    <Menu.Item
                                                        onClick={e => this.profileNavigation(e, _name.ref)}
                                                        key={_index}
                                                        className={`${_index == 0 ? "active" : ""}`}
                                                    >
                                                        {_name.val}{" "}
                                                        <Icon className="xcm-icon-angle-right icon" />
                                                    </Menu.Item>
                                                ) : (
                                                    ""
                                                );
                                        } else
                                            return _name.show ? (
                                                <Menu.Item
                                                    onClick={e => this.profileNavigation(e, _name.ref)}
                                                    key={_index}
                                                    className={`${_index == 0 ? "active" : ""}`}
                                                >
                                                    {_name.val}{" "}
                                                    <Icon className="xcm-icon-angle-right icon" />
                                                </Menu.Item>
                                            ) : (
                                                    ""
                                                );
                                    })}
                                </Menu>
                            </Grid.Column>

                            <Grid.Column width={13} className="js-formSections">
                                <div ref={this.UserForm}></div>

                                <Header as="h2" dividing className="js-title">
                                    User Details
                </Header>

                                <Grid columns={2} className="form_userDetails">
                                    <Grid.Row>
                                        <Grid.Column>
                                            <section className="myForm ui form">
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label> First Name</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.first_name.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="first_name"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.first_name.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.first_name.maxLength}
                                                                value={this.state.first_name.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "first_name")
                                                                }

                                                                required
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>

                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label> Last Name</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.last_name.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="last_name"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.last_name.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.last_name.maxLength}
                                                                value={this.state.last_name.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "last_name")
                                                                }
                                                                required
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>

                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label>Email / Login ID</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.email_id.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="email_id"
                                                                autocomplete="false"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.email_id.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.email_id.maxLength}
                                                                value={this.state.email_id.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "email_id")
                                                                }
                                                                required
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className={`form_grid ${!this.state.password.show ? "hide" : ""
                                                    }`}>
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label>Password
                                                                    <Popup
                                                                        content="Password must have minimum of 8 characters and must contain one of @#$%^&*/."
                                                                        trigger={
                                                                            <svg className={`svg_icon xcm-icon-info size-20 orange ml-4`}>
                                                                                <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}> </use>
                                                                            </svg>
                                                                        }
                                                                    />
                                                                </label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.password.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="password"
                                                                name="password"
                                                                autocomplete="new-password"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.state.UserGuid.value != "" && this.state.UserGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.password.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.password.maxLength}
                                                                value={this.state.password.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "password")
                                                                }
                                                                onFocus={(event) => event.target.select()}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className={`form_grid ${!this.state.confirmpassword.show ? "hide" : ""
                                                    }`}>
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label>Confirm Password</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.confirmpassword.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="password"
                                                                name="confirmpassword"
                                                                autocomplete="new-password"
                                                                className={`${this.state.confirmpassword.changed
                                                                    ? "editedCellColor"
                                                                    : ""
                                                                    }`}
                                                                maxLength={this.state.confirmpassword.maxLength}
                                                                value={this.state.confirmpassword.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "confirmpassword")
                                                                }

                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid"> 
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Employee ID
                                                                <Popup
                                                                    content="Allowed: letters (a–z, A–Z), digits (0–9), and _ ' @ . # -"
                                                                    trigger={
                                                                        <svg className={`svg_icon xcm-icon-info size-20 orange ml-4`}>
                                                                            <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}></use>
                                                                        </svg>
                                                                    }
                                                                    /></label>
                                                            </Form.Field>                                                            
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.employee_id.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="employee_id"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.employee_id.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.employee_id.maxLength}
                                                                value={this.state.employee_id.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={(e) => {
                                                                    this.textColorChange(e, "employee_id");
                                                                    this.validateEmployeeIdOnBlur(e);
                                                                }}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Department</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.department.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="department"
                                                                fluid
                                                                search
                                                                multiple
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("department", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.department
                                                                        : []
                                                                }
                                                                value={this.state.department.value}
                                                                className={`${this.state.department.edited ? "edited" : ""}`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>


                                                <Grid columns={2} className="form_grid ip_field">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>
                                                                    IP Address Restriction Range{" "}
                                                                    <Popup
                                                                        content="Enter the first field to restrict access to a single IP address, or both to enter an IP address range."
                                                                        trigger={
                                                                            <svg className={`svg_icon xcm-icon-info size-20 orange`}>
                                                                                <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}> </use>
                                                                            </svg>
                                                                        }
                                                                    />
                                                                </label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.LandingPageId.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Grid.Column width={5}>
                                                                <Grid columns={4}>
                                                                    {this.state.IP_from.value.map((x, i) =>
                                                                        this.buildIPAddress(x, i)
                                                                    )}
                                                                    <Grid.Row>
                                                                        <Grid.Column width={7}>
                                                                            <button
                                                                                className="ui basic button"
                                                                                onClick={e => this.addNewIP(e)}
                                                                            >
                                                                                <i className="icon plus"></i>
                                        Add New
                                      </button>
                                                                        </Grid.Column>
                                                                    </Grid.Row>
                                                                </Grid>
                                                            </Grid.Column>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </section>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <section className="myForm ui form">
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Middle Name / Initial</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.middle_name.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="middle_name"
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.middle_name.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                maxLength={this.state.middle_name.maxLength}
                                                                value={this.state.middle_name.value}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "middle_name")
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Suffix</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.generation_type.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="generation_type"
                                                                selectOnBlur={false}
                                                                fluid
                                                                search
                                                                selection
                                                                value={this.state.generation_type.value}
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("generation_type", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.generation_type
                                                                        : []
                                                                }
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.generation_type.edited
                                                                        ? "edited"
                                                                        : "")
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Phone</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.phone_number.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <PhoneInput
                                                                preferredCountries={['us', 'in']}
                                                                country={'us'}
                                                                areaCodes={{ca: ["263","354","367","368","382","428","468","474","584","683","753"]}}
                                                                disableInitialCountryGuess={this.urlPath.includes("edituser") ? true : false}
                                                                value={this.state.countryCode.value + ' ' + this.state.phone_number.value}
                                                                inputClass={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.phone_number.changed
                                                                        ? "editedCellColor"
                                                                        : "")
                                                                    }`}
                                                                enableLongNumbers={true}
                                                                countryCodeEditable={true}
                                                                onChange={(value, country, e, formattedValue) => {
                                                                    this.statechanged = true;
                                                                    this.state.phone_number.default = value.slice(country.dialCode.length);
                                                                    let number = formattedValue.trim();
                                                                    this.state.phone_number.value = number.includes(' ') ? number.substr(number.indexOf(' ') + 1) : '';
                                                                    this.state.countryCode.value = '+' + country.dialCode;
                                                                    this.state.phone_number.changed = true;
                                                                    this.state.phone_number.edited = true;
                                                                    this.state.phone_number.error = false;
                                                                    this.state.countryCode.changed = true;
                                                                    this.state.countryCode.edited = true;
                                                                    this.setState({ ...this.statechanged });
                                                                }}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field required>
                                                                <label>Primary Location</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.branch_id.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="branch_id"
                                                                selectOnBlur={false}
                                                                fluid
                                                                search
                                                                selection
                                                                disabled={!this.GLOBALUSER}
                                                                value={this.state.branch_id.value}
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("branch_id", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.firmBranches
                                                                        : []
                                                                }
                                                                className={`${(this.state.branch_id.edited ? "edited" : "")}`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Task Location</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.task_locations.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="task_locations"
                                                                fluid
                                                                search
                                                                multiple
                                                                selection
                                                                value={this.state.task_locations.value}
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("task_locations", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.firmBranches
                                                                        : []
                                                                }
                                                                className={`${this.state.task_locations.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>

                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>User Group</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.belongsto_group.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="belongsto_group"
                                                                fluid
                                                                search
                                                                multiple
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("belongsto_group", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.rightsGroupNames
                                                                        : []
                                                                }
                                                                value={this.state.belongsto_group.value}
                                                                className={`${this.state.belongsto_group.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Employee Type</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className="inline fields margintop_fields "
                                                        >
                                                            <Grid columns={2}>
                                                                <Grid.Row>
                                                                    <Grid.Column width={6}>
                                                                        <div className="field">
                                                                            <div className="ui radio checkbox">
                                                                                <input
                                                                                    type="radio"
                                                                                    name="parttime_employee"
                                                                                    onChange={e => this.handleChange(e)}
                                                                                    checked={
                                                                                        this.state.parttime_employee
                                                                                            .value === "0"
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                    value="0"
                                                                                />
                                                                                <label>Full Time</label>
                                                                            </div>
                                                                        </div>
                                                                    </Grid.Column>
                                                                    <Grid.Column width={6}>
                                                                        <div className="field">
                                                                            <div className="ui radio checkbox">
                                                                                <input
                                                                                    type="radio"
                                                                                    name="parttime_employee"
                                                                                    onChange={e => this.handleChange(e)}
                                                                                    checked={
                                                                                        this.state.parttime_employee
                                                                                            .value === "1"
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                    value="1"
                                                                                />
                                                                                <label>Part Time</label>
                                                                            </div>
                                                                        </div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </Grid>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <div
                                                    className={`errmsg ${this.state.error_signal.value
                                                        ? "errshow"
                                                        : "errhide"
                                                        }`}
                                                >
                                                    {this.state.error_signal.msg}
                                                </div>
                                            </section>
                                        </Grid.Column>
                                        </Grid.Row>
                                    </Grid>


                                    <Header as="h2" dividing>
                                        More Details
                                    </Header>
                                    <Grid columns={2}>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <section className="myForm ui form">
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Title/Level</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.title_level.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="title_level"
                                                                selectOnBlur={false}
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" : (this.state.title_level.edited ? "edited" : "")
                                                                    }`}
                                                                fluid
                                                                search
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("title_level", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.titleLevelList
                                                                        : []
                                                                }
                                                                value={this.state.title_level.value}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Primary Role</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.primary_role.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="primary_role"
                                                                selectOnBlur={false}
                                                                className={`${this.state.primary_role.edited ? "edited" : ""
                                                                    }`}
                                                                fluid
                                                                search
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("primary_role", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.rolesDetails
                                                                        : []
                                                                }
                                                                value={this.state.primary_role.value}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Industry Group</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.industry_group.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="industry_group"
                                                                fluid
                                                                multiple
                                                                search
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("industry_group", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.industry
                                                                        : []
                                                                }
                                                                value={this.state.industry_group.value}
                                                                className={`${this.state.industry_group.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Work Experience Begin Date </label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column width={11} className="ui icon input">
                                                            <i className="icon calendar alternate j-calendar"></i>
                                                            <DatePicker
                                                                selected={this.assignDate(
                                                                    this.state.wrk_exp_begindate.value
                                                                )}
                                                                onChange={date => this.calenderChange(date)}
                                                                maxDate={new Date()}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                dateFormat="MM/dd/yyyy"
                                                                placeholderText=""
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                className={`${this.state.wrk_exp_begindate.changed
                                                                    ? "editedCellColor"
                                                                    : ""
                                                                    }`}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "wrk_exp_begindate")
                                                                }
                                                            />
                                                            {/*<ModernDatepicker placeholder="Date" className="moderndatepicker" date={this.state.wrk_exp_begindate.value} format={'MM / DD / YY'} minDate={new Date("1900,1,1")} onChange={(date) => this.calenderChange(date)} />   */}
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Secondary Billing Rate</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.secondarybilling_rate.error
                                                                ? "error"
                                                                : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="secondarybilling_rate"
                                                                className={`${this.state.secondarybilling_rate.changed
                                                                    ? "editedCellColor"
                                                                    : ""
                                                                    }`}
                                                                value={this.state.secondarybilling_rate.value}
                                                                maxLength={
                                                                    this.state.secondarybilling_rate.maxLength
                                                                }
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(
                                                                        e,
                                                                        "secondarybilling_rate"
                                                                    )
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </section>
                                        </Grid.Column>

                                        <Grid.Column className="myForm ui form">
                                            <section className="myForm ui form">
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Expertise</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.expertise.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="expertise"
                                                                search
                                                                multiple
                                                                fluid
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("expertise", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.expertise
                                                                        : []
                                                                }
                                                                value={this.state.expertise.value}
                                                                className={`${(this.state.StaffGuid.value != "" && this.state.StaffGuid.value != null && this.FirmLinkedToAxcess) ?
                                                                    "wkuserdetailsdisabled" :
                                                                    (this.state.expertise.edited
                                                                        ? "edited"
                                                                        : "")
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Secondary Role</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.secondary_role.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="secondary_role"
                                                                selectOnBlur={false}
                                                                className={`${this.state.secondary_role.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                                search
                                                                fluid
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("secondary_role", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.rolesDetails
                                                                        : []
                                                                }
                                                                value={this.state.secondary_role.value}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Niche Group</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.niche_group.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="niche_group"
                                                                fluid
                                                                multiple
                                                                search
                                                                selection
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange("niche_group", {
                                                                        value
                                                                    })
                                                                }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.props.profile_lookup.nicheGroups
                                                                        : []
                                                                }
                                                                value={this.state.niche_group.value}
                                                                className={`${this.state.niche_group.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Years of Experience</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.YearsOfExp.error ? "error" : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="YearsOfExp"
                                                                className={`${this.state.YearsOfExp.changed
                                                                    ? "editedCellColor"
                                                                    : ""
                                                                    }`}
                                                                value={this.state.YearsOfExp.value}
                                                                maxLength={this.state.YearsOfExp.maxLength}
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "YearsOfExp")
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Primary Billing Rate</label>
                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.primarybilling_rate.error
                                                                ? "error"
                                                                : ""
                                                                }`}
                                                        >
                                                            <input
                                                                type="text"
                                                                name="primarybilling_rate"
                                                                className={`${this.state.primarybilling_rate.changed
                                                                    ? "editedCellColor"
                                                                    : ""
                                                                    }`}
                                                                value={this.state.primarybilling_rate.value}
                                                                maxLength={
                                                                    this.state.primarybilling_rate.maxLength
                                                                }
                                                                onChange={e => this.handleChange(e)}
                                                                onBlur={e =>
                                                                    this.textColorChange(e, "primarybilling_rate")
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </section>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Grid.Column width={13} className="js-formSections">
                                    <Header as="h2" dividing className="js-title">
                                        User Preferences
                </Header>

                                    <Grid columns={2} className="form_userDetails">
                                        <Grid.Row>
                                            <Grid.Column>
                                                <section className="myForm ui form">
                                                    <Grid columns={2} className="form_grid">

                                                        <Grid.Row>

                                                            <Grid.Column width={5}>
                                                                <Form.Field>
                                                                    <label>Pinned View for MyView
                                   <Popup
                                                                            content="Users can have up to 7 views pinned to their MyView."
                                                                            trigger={
                                                                                <svg className={`svg_icon xcm-icon-info size-20 orange ml-4`}>
                                                                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-info`}> </use>
                                                                                </svg>
                                                                            }
                                                                        />
                                                                    </label>
                                                                </Form.Field>
                                                            </Grid.Column>
                                                            <Grid.Column
                                                                width={11}
                                                                className={`required field ${this.state.page_id.error ? "error" : ""
                                                                    }`}
                                                            >
                                                                <Dropdown
                                                                    clearable
                                                                    placeholder="Select"
                                                                    name="page_id"
                                                                    fluid
                                                                    search
                                                                    multiple
                                                                    selection
                                                                    value={this.state.page_id.value}
                                                                    onChange={(e, { value }) =>
                                                                        this.handleDropdownChange("page_id", {
                                                                            value
                                                                        })
                                                                    }
                                                                    options={
                                                                        this.props.profile_lookup
                                                                            ? this.props.profile_lookup.pageDetails
                                                                            : []
                                                                    }
                                                                    className={`${this.state.page_id.edited
                                                                        ? "edited"
                                                                        : ""
                                                                        }`}
                                                                />
                                                            </Grid.Column>




                                                            {/* ---------------- */}
                                                            <Divider hidden />
                                                            <Grid.Column width={5} style={{ marginTop: '15px' }}>
                                                                <Form.Field>
                                                                    <label>Default Category</label>
                                                                </Form.Field>
                                                            </Grid.Column>
                                                            <Grid.Column
                                                                width={11}
                                                                style={{ marginTop: '15px' }}
                                                            >
                                                                <Dropdown
                                                                    clearable
                                                                    placeholder="Select"
                                                                    name="defaultCategory"
                                                                    selectOnBlur={false}
                                                                    fluid
                                                                    search
                                                                    selection
                                                                    className={`${this.state.defaultCat.edited
                                                                        ? "edited"
                                                                        : ""
                                                                        }`}
                                                                    value={this.selectDefaultCategory()}
                                                                    //value={(() => {
                                                                    // if(this.state.defaultCategory == 0) {
                                                                    //   return ""
                                                                    // }
                                                                    // if(this.props.categories && this.props.categories.length) {
                                                                    //   const defaultCat = this.props.categories.filter(el => el.category_id === this.state.defaultCategory);
                                                                    //   if(defaultCat && defaultCat.length) {
                                                                    //     return defaultCat[0].name
                                                                    //   }else {
                                                                    //     // alert("Inactive categories cannot be selected")
                                                                    //     const mySuccessNotification = {
                                                                    //       message: "Default category cannot be selected since the category is in inactive state",
                                                                    //       type: NOTIFICATION_TYPE_WARNING,
                                                                    //       duration: 5000,
                                                                    //       canDismiss: true,
                                                                    //       showCloseAllBtn: true
                                                                    //     };
                                                                    //     this.props.createNotification(mySuccessNotification);
                                                                    //     return ""
                                                                    //   }
                                                                    // }else{
                                                                    //   return ""
                                                                    // }
                                                                    // })()}
                                                                    onChange={(e, { value }) => {
                                                                        this.statechanged = true;
                                                                        if (value == "") {
                                                                            this.setState({ defaultCat: { ...this.state.defaultCat, edited: true, defaultCategory: 0 } });
                                                                            //this.setState({defaultCategory: 0})
                                                                        } else {
                                                                            //let userIdObj = this.props.match.params;
                                                                            let catId = this.props.categories.length ? this.props.categories.filter(el => el.name === value)[0].category_id : 0;

                                                                            // if(Object.keys(userIdObj).length == 0) {
                                                                            //   console.log("Coming here for new user")
                                                                            //   this.setState({defaultCategory: 0})
                                                                            //   catId = this.props.categories.length ? this.props.categories.filter(el => el.name === value)[0].category_id : 0;
                                                                            // }

                                                                            this.statechanged = true;
                                                                            this.setState({ defaultCat: { ...this.state.defaultCat, edited: true, defaultCategory: catId } });
                                                                            //this.setState({defaultCategory: catId})
                                                                        }
                                                                    }
                                                                    }
                                                                    // options={[
                                                                    //   {key: 0, text: "Tax", value: "Tax"},
                                                                    //   {key: 1, text: "Bookkeeping", value: "Bookkeeping"},
                                                                    //   {key: 2, text: "Financial", value: "Financial"},
                                                                    //   {key: 3, text: "Others", value: "Others"}
                                                                    // ]}
                                                                    options={
                                                                        this.props.categories && this.props.categories.length ? this.props.categories.map((el) => {
                                                                            return {
                                                                                key: el.category_id,
                                                                                text: el.name,
                                                                                value: el.name
                                                                            }
                                                                        }) : []
                                                                    }
                                                                    fluid
                                                                    search
                                                                    selection
                                                                />
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                </section>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Grid columns={2} className="form_grid">
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Form.Field>
                                                                <label>Default MyView View</label>

                                                            </Form.Field>
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            width={11}
                                                            className={`required field ${this.state.LandingPageId.error ? "error" : ""
                                                                }`}
                                                        >


                                                            <Dropdown
                                                                clearable
                                                                placeholder="Select"
                                                                name="LandingPageId"
                                                                className={`${this.state.LandingPageId.edited
                                                                    ? "edited"
                                                                    : ""
                                                                    }`}
                                                                selectOnBlur={false}
                                                                fluid
                                                                search
                                                                selection
                                                                value={this.state.LandingPageId.value}
                                                                onChange={(e, { value }) =>
                                                                    this.handleDropdownChange(
                                                                        "LandingPageId",
                                                                        { value },
                                                                        e
                                                                    )
                                                                }
                                                                // options={
                                                                //   this.props.profile_lookup
                                                                //     ? this.props.profile_lookup.pageDetails
                                                                //     : []
                                                                // }
                                                                options={
                                                                    this.props.profile_lookup
                                                                        ? this.defaultViewOptions()
                                                                        : []
                                                                }
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>
                                <Divider hidden />

                                {this.props.profile_lookup.ShowRAS &&
                                    this.state.parttime_employee.value === "1" ? (
                                        <RASCal
                                            event={this.EditWeek}
                                            keypress={this.handleRASChange}
                                            daychange={this.RASdaychange}
                                            click={this.addRASDetails}
                                            delete={this.deleteRASDetails}
                                            mouseover={this.RASinfopop}
                                            dataObj={[...this.state.ResourceAvailabilities.value]}
                                            RASInfo={this.props}
                                            RASerror={this.state.ResourceAvailabilities.error}
                                            RASerrormsg={this.state.ResourceAvailabilities.errormsg}
                                        />
                                    ) : (
                                        ""
                                    )}

                                <UserRights
                                    rightsObj={this.state.UserRights.value}
                                    change={this.userRightsChange.bind(this)}
                                    renderstate={this.state.rights_change.value}
                                ></UserRights>


                                <Divider hidden />
                            </Grid.Column>

                        </Grid.Row>
                    </Grid>
                </form>

                <NotificationStack
                    dismissInOrder={true}
                    notifications={this.state.notifications}
                    onDismiss={this.onDismiss.bind(this)}
                />
            </>
        );
    }
}
const mapProperties = state => {
    return {
        profile_lookup: state.createUserReducer.userProfileLook,
        user_details: state.createUserReducer.userData,
        db_status: state.createUserReducer.insertstatus,
        error: state.createUserReducer.error,
        categories: state.allCategories.activeCategories,
        failedCount: state.createUserReducer.failedCount
    };
};

const dispatch_action = dispatch => {
    //console.log("userDetails.UserContext.firmId", userDetails.UserContext.firmId)
    let firmId = userDetails && userDetails.UserContext.firmId ? userDetails.UserContext.firmId : 697;
    return {
        GET_USER_LOOKUPS: () => dispatch(action_type._load_userlookups()),
        GET_USER_DETAILS: _id => dispatch(action_type._get_userdetails(_id)),
        POST_USER_DETAILS: (_state, _props) =>
            dispatch(action_type._post_userdata(_state, _props)),
        PUT_USER_DETAILS: (_state, _props) =>
            dispatch(action_type._update_userdata(_state, _props)),
        CHANGE_STATUS: () => dispatch(action_type._change_status()),
        CHANGE_MYCALENDER: (_action) => dispatch(action_type._mycalender_bucket(_action)),
        createNotification: config => {
            dispatch(createNotification(config));
        },
        fetchActiveCategories: () => dispatch(fetchActiveCategories(firmId)),
    };
};

export default connect(
    mapProperties,
    dispatch_action
)(CreateUser);
